module.exports = __webpack_public_path__ + "static/img/customer_not.7d40ec46.png";